import { Component, OnInit, Input } from '@angular/core';
import { BarController, BarElement, CategoryScale, Chart, ChartType, LinearScale, LineController, LineElement, PointElement, Title } from 'chart.js';

@Component({
  selector: 'app-statistic-chart',
  templateUrl: './statistic-chart.component.html',
  styleUrls: ['./statistic-chart.component.scss']
})
export class StatisticChartComponent implements OnInit {
  @Input() data: any;

  public statisticId: string;

  ngOnInit() {
    
  }

  ngAfterViewInit(){
    Chart.register(LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, BarController,BarElement );

    this.statisticId = this.data.statisticsTemplateId;

    let chartType: ChartType = this.data.barChartType;
    let chartLabels: string[] = this.data.barChartLabels;
    let chartBackgroundColorsRaw: string[] = this.data.lineChartColors;
    let chartBackgroundColors: any[] = [];
    let xAxisTitle: string = this.data.xAxisTitle;
    let yAxisTitle: string = this.data.yAxisTitle;
    let chartDataSetsRaw: any[] = this.data.ngx2SerieChartDataSets;
    let chartDataSets: any[] = [];

    if (chartDataSetsRaw != null) {
      chartDataSetsRaw.forEach(function (datatserie) {
        chartDataSets.push({
          data: datatserie.data,
          label: datatserie.serieLabel,
          borderColor: null,
          backgroundColor: null
        });
      });
    }

    chartBackgroundColorsRaw.forEach(function (color) 
    {
      chartBackgroundColors.push(
        {
        borderColor: color,
        backgroundColor: color,
        pointBackgroundColor: color,
        pointHoverBackgroundColor: 'rgb(209, 29, 29)'
        
        })
    });

    chartDataSets.map((data, index) => {
      Object.assign(data, chartBackgroundColors[index])
    });

    const data = {
      labels: chartLabels,
      datasets: chartDataSets
    };


    const options = {
      scales: {
        x: {
          title: {
            display: true,
            text: xAxisTitle
          }
        },
        y: {
          //min: min,
          //max: max,
          title: {
            display: true,
            text: yAxisTitle
          }
        }
      },
      plugins: {
        title: {
            display: true,
            text: this.data.reportTitle
        }
    }
    }
  
    const xValues = [50,60,70,80,90,100,110,120,130,140,150];
const yValues = [7,8,8,9,9,9,10,11,14,14,15];
    new Chart(
      <HTMLCanvasElement>document.getElementById(this.statisticId),
      // "testChart",
      {
        type: chartType,
        data: data,
        options: options
      }
    );
  }
}

